// API Configuration
export const API_BASE_URL_V1 = process.env.REACT_APP_API_BASE_URL_V1 || 'http://localhost:8080/api/v1';
export const API_BASE_URL_ADMIN = process.env.REACT_APP_API_BASE_URL_ADMIN || 'http://localhost:8080/api/admin';

// Google Maps API Configuration
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyD3sEinlT19E_TtzKwwh3LTfbVDkXNzalQ';